import React from "react";
import { createPortal } from "react-dom";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-head text-2xl sm:text-3xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
    </div>
  );
}

export function Btn({ children, variant = "primary", className = "", ...props }) {
  const base = "inline-flex items-center justify-center gap-2 h-10 px-4 rounded-lg text-sm font-semibold transition-colors disabled:opacity-60";
  const styles = {
    primary: "bg-primary text-primary-foreground hover:bg-primary/90",
    outline: "border border-border hover:bg-accent",
    ghost: "hover:bg-accent text-muted-foreground hover:text-foreground",
    danger: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
    success: "bg-emerald-600 text-white hover:bg-emerald-700",
  };
  return <button className={`${base} ${styles[variant]} ${className}`} {...props}>{children}</button>;
}

export function StatCard({ label, value, icon: Icon, accent = "text-primary", sub }) {
  return (
    <div className="card-surface p-5">
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{label}</p>
        {Icon && <Icon className={`w-5 h-5 ${accent}`} />}
      </div>
      <p className="font-data text-2xl font-bold mt-2">{value}</p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
}

export function Input(props) {
  return <input {...props} className={`w-full h-10 px-3 rounded-lg bg-secondary border border-border focus:border-primary focus:outline-none transition-colors ${props.className || ""}`} />;
}

export function Modal({ open, onClose, title, children, wide, xl, top }) {
  const downOnBackdrop = React.useRef(false);
  if (!open) return null;
  return createPortal(
    <div className={`fixed inset-0 z-[60] flex ${top ? "items-start" : "items-center"} justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto`}
      onMouseDown={(e) => { downOnBackdrop.current = e.target === e.currentTarget; }}
      onClick={(e) => { if (downOnBackdrop.current && e.target === e.currentTarget) onClose(); downOnBackdrop.current = false; }}>
      <div className={`card-surface w-full ${xl ? "max-w-5xl" : wide ? "max-w-2xl" : "max-w-md"} max-h-[88vh] overflow-y-auto p-6 ${top ? "mt-6 mb-6" : ""}`}>
        <div className="flex items-start justify-between gap-3 mb-4">
          <h3 className="font-head text-xl font-bold">{title}</h3>
          <button type="button" onClick={onClose} aria-label="Cerrar" data-testid="modal-close" className="w-8 h-8 shrink-0 rounded-md hover:bg-accent flex items-center justify-center text-muted-foreground hover:text-foreground">✕</button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
}

export function StatusPill({ status }) {
  const map = {
    normal: "bg-emerald-500/10 text-emerald-500 border-emerald-500/30",
    bajo: "bg-amber-500/10 text-amber-500 border-amber-500/30",
    agotado: "bg-red-500/10 text-red-500 border-red-500/30",
  };
  const labels = { normal: "Normal", bajo: "Bajo", agotado: "Agotado" };
  return <span className={`text-xs px-2 py-0.5 rounded-full border font-medium ${map[status] || map.normal}`}>{labels[status] || status}</span>;
}
